<template>
  <div id="dd-left">
    <!-- 地图 -->
    <map-container
      ref="MapContainer"
      :serviceProviderList="serviceProviderList"
      @endDriving="endDriving"
    ></map-container>
    <!-- 头部内容 -->
    <div class="top-content">
      <div class="top-bg-img">
        <div class="dd-type-name" @clicl="Map()">滴滴叫修智慧大屏</div>
        <div class="dd-top-right">
          <div class="right-weather" v-if="weatherDto.areaName">
            <div class="weather-icon">
              <i
                class="weather--menu-icon sun"
                v-if="weatherDto.weather === '晴'"
              ></i>
              <i
                class="weather--menu-icon cloudy"
                v-if="weatherDto.weather === '多云'"
              ></i>
              <i
                class="weather--menu-icon overcast"
                v-if="weatherDto.weather === '阴'"
              ></i>
              <i
                class="weather--menu-icon rain"
                v-if="weatherDto.weather === '雨' || weatherDto.weather === '小雨'"
              ></i>
              <i
                class="weather--menu-icon snow"
                v-if="weatherDto.weather === '霾'"
              ></i>
            </div>
            <div>{{ weatherDto.temperature }}°C</div>
            <div>{{ weatherDto.weather }}</div>
            <div>
              湿度:<span > {{ weatherDto.humidity }}% </span>
            </div>
            <div>{{ weatherDto.areaName }}</div>
          </div>

          <div class="dd-top-tiem">{{ currentTime }}</div>
        </div>
      </div>
    </div>
    <!-- 服务商列表 -->
    <div class="dd-service-list">
      <div class="dd-service-text">
        <div class="dd-service-text-name">服务商列表</div>
      </div>
      <div class="">
        <el-input
          class="dd-service-input"
          v-model="searchInput"
          placeholder="搜索工程师"
          @keyup.enter.native="search"
        ></el-input>
      </div>
      <div class="dd-number-people">
        <div class="number-people">
          <div class="line on-line">
            <div class="dd-on-scanning2"></div>
            {{ serviceProviderNumber.isOnLineCount }}
          </div>
          <div class="on-line-text">在线人数 (人)</div>
        </div>
        <div class="number-people">
          <div class="line off-line">
            <div class="dd-off-scanning"></div>
            {{ serviceProviderNumber.isUnLineCount }}
          </div>
          <div class="off-line-text">离线人数 (人)</div>
        </div>
      </div>
      <!--  -->


      <div class="dd-number-people-list">

        <ul class="infinite-list number-people-list" v-infinite-scroll="load" style="overflow:auto" >
          <li v-for="(item,index) in pagingServiceList" :key="index" class="list-item"
            @click="serviceProvider(item, index)"
            :class="itemIcon === index ? 'item-icon' : ''">
            <div class="item-people">
              <img
                :src="item.fileUrl"
                class="item-img"
              />
              <div class="people-distance">
                <div>{{ item.receiveNick }}</div>
                <div class="least-text">
                  <i class="dd-icon03"></i>
                  距离你：{{ item.distance }}km
                </div>
              </div>
            </div>
            <div class="item-state">
              <div class="dd-on-butt" v-if="item.userDto.isOnline">
                <i class="on-spot"></i>
                <div>在线</div>
              </div>

              <div class="dd-off-butt" v-else>
                <i class="off-spot"></i>
                <div>离线</div>
              </div>
              <img class="dd-icon06" src="../assets/dd/dd-icon06.png" alt="" />
            </div>

          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <!-- <p v-if="noMore">没有更多了</p> -->
        <!-- <div class="number-people-list">
          <div
            v-for="(item, index) in pagingServiceList"
            :key="index"
            class="list-item"
            @click="serviceProvider(item, index)"
            :class="itemIcon === index ? 'item-icon' : ''"
          >
            <div class="item-people">
              <img
                :src="item.userDto.fileDtoList[0].fileUrl"
                class="item-img"
              />
              <div class="people-distance">
                <div>{{ item.receiveNick }}</div>
                <div class="least-text">
                  <i class="dd-icon03"></i>
                  距离你：{{ item.distance }}km
                </div>
              </div>
            </div>
            <div class="item-state">
              <div class="dd-on-butt" v-if="item.userDto.isOnline">
                <i class="on-spot"></i>
                <div>在线</div>
              </div>

              <div class="dd-off-butt" v-else>
                <i class="off-spot"></i>
                <div>离线</div>
              </div>
              <img class="dd-icon06" src="../assets/dd/dd-icon06.png" alt="" />
            </div>
          </div> 
        </div>-->
      </div>
    </div>
    <!-- 数据总览 -->
    <div class="dd-overview">
      <div class="dd-overview-top">
        <button v-if="isDriving" class="bott-butt" @click="cancelDriving">
          取消导航
        </button>
      </div>
      <div class="overview">
        <div class="dd-overview-text">
          <div class="dd-overview-text-name">数据总览</div>
        </div>
        <div class="overview-bott">
          <div class="overview-item">
            <div style="margin-left:10px">
              <arc-progress-bar :value="onLinePercentage"></arc-progress-bar>
              <div style="color:#fff">工程师在线率</div>
            </div>
            <div class="overview-bg">
              <div class="people">
                <span class="peopleW">总人数:</span
                ><span class="people-color">{{ serviceProviderNumber.isOnLineCount +serviceProviderNumber.isUnLineCount }}</span>
              </div>
              <div class="people">
                <span class="peopleW">在线人数:</span
                ><span class="people-color2">{{ serviceProviderNumber.isOnLineCount }}</span>
              </div>
            </div>
          </div>
          <div class="overview-item">
            <img class="dd-icon" src="../assets/dd/dd-profit.png" alt="" />
            <div>
              <div class="overview-text">{{platformStatistic.earningsTotal}}</div>
              <div class="overview-least-text">平台累计总收益 (元)</div>
            </div>
          </div>
          <div class="overview-item">
            <img class="dd-icon" src="../assets/dd/dd-chart.png" alt="" />
            <div>
              <div class="overview-text">{{platformStatistic.orderTotal}}</div>
              <div class="overview-least-text">滴滴叫修工单（单）</div>
            </div>
          </div>
          <div class="overview-item">
            <img class="dd-icon" src="../assets/dd/dd-more.png" alt="" />
            <div>
              <div class="overview-text">{{platformStatistic.praise}}%</div>
              <div class="overview-least-text">服务满意度 （好评）</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 左边弹窗 -->
    <!-- <let-popup :largeScreenType='2'></let-popup> -->
  </div>
</template>

<script>
import { socketUtil } from "@/utils/dd-websocket/socketUtil.js";
import { SocketInit } from "@/utils/websocket/socketUtil.js";
import MapContainer from "@/components/MapContainer.vue";
import serviceMap from "@/components/serviceMap.vue";
import arcProgressBar from "@/components/arc_progress_bar.vue";
// import letPopup from '@/components/letPopup'
import util from "@/utils/util.js";

export default {
  mixins: [socketUtil, SocketInit], //混入文件
  components: {
    MapContainer,
    serviceMap,
    arcProgressBar,
    // letPopup
  },
  data() {
    return {
      util,
      timingDate: null, // 当前时间定时器
      currentTime: "", // 当前时间
      isDriving: false,
      onLinePercentage:0, // 在线人数百分比
      // 天气
      weatherDto: {
        areaId: "",
        areaName: "",
        humidity: "",
        isDelete: false,
        temperature: "",
        weather: "",
        weatherId: "",
        windDirection: "",
        windPower: "",
      },
      itemIcon: 0,
      searchInput: "",
      serviceProviderList: [], // 服务商列表
      pagingServiceList:[], // 分页服务商列表
      serviceProviderNumber: {
        //  服务商人数
        isOnLineCount: 0,
        isUnLineCount: 0,
      },
      platformStatistic:{
        praise: 0,
        earningsTotal:'0',
        orderTotal:0
      },
      pages:0,
      loading: false,
      isload:false
    };
  },
  created() {
    this.timingDate = setInterval(() => {
      /* 时间 */
      this.currentTime = this.util.formatDatetiem();
    }, 1000);
  },
  beforeMount() {
    this.initSocket("dd12");
    this.initSocketDD("dd12");
    
  },
  destroyed() {
    clearInterval(this.timingDate);
  },
  methods: {
    // 搜索分页
    load () {
      if(!this.isload ){
          this.isload = true
      }else{
          // this.page = this.pages
         this.loading = true
        setTimeout(() => {
          this.page++
          this.getServiceProviderPage()
          this.loading = false
        }, 500)
      }
        
      },
    endDriving(e) {
      this.isDriving = true;
    },
    cancelDriving() {
      this.isDriving = false;
      this.$refs.MapContainer.cancelDriving();
    },
    // 搜索工程师
    search(e){
      this.pagingServiceList = []
      this.page = 1
      this.engineerName = this.searchInput
      this.getServiceProviderPage()
    },
    //   选择服务商
    serviceProvider(item, index) {
      this.itemIcon = index;
      this.$refs.MapContainer.customWindow(item);
    },
    acceptProviderData(data) {
      console.log("服务商信息----------", data);
      // 
      if (data.providerOnlineDto) {
        console.log("服务商人数----------",data.providerOnlineDto);
        this.serviceProviderNumber.isOnLineCount =
          data.providerOnlineDto.isOnLineCount;
        this.serviceProviderNumber.isUnLineCount =
          data.providerOnlineDto.isUnLineCount;
       let serviceProviderTotal =  data.providerOnlineDto.isUnLineCount + data.providerOnlineDto.isOnLineCount
       this.onLinePercentage = (this.serviceProviderNumber.isOnLineCount/serviceProviderTotal)*100
       this.onLinePercentage = Number(this.onLinePercentage.toFixed(2))
       
        this.getProviderByPosition();
        if( this.isload ){
          this.page = 1
          this.pagingServiceList= []
          this.getServiceProviderPage()
        }
        
      }
      //    首次服务商列表
      if (data.providerInfoDTOList && data.providerInfoDTOList.length > 0) {
        console.log("服务商列表----------",data.providerInfoDTOList);
        let item_list = [];
        this.serviceProviderList = []
        data.providerInfoDTOList.forEach((item) => {
          item.distance = this.util.Intercept(String(item.distance));
          let list = [];
          list.push([
            item.serviceProviderDto.providerPositionDto.longitude,
            item.serviceProviderDto.providerPositionDto.latitude,
          ]);
          item_list.push({
            userDto: item.serviceProviderDto.userDto,
            appraise: item.appraise,
            distance: item.distance,
            fileUrl: item.serviceProviderDto.userDto.fileDtoList[0].fileUrl,
            time: item.time,
            longitude_latitude: list,
            receiveNick:item.serviceProviderDto.receiveNick
          });
        });
        this.serviceProviderList = item_list;
        console.log("item_list", this.serviceProviderList);
      }
      // 搜索服务商列表
      if(data.providerInfoDTOPageDto && data.providerInfoDTOPageDto.records.length > 0){

         console.log("分页服务商列表----------",data.providerInfoDTOList);
         this.getProviderByPosition()
          let item_list = [];
          
        
        data.providerInfoDTOPageDto.records.forEach((item) => {
          item.distance = this.util.Intercept(String(item.distance));
          let list = [];
          list.push([
            item.serviceProviderDto.providerPositionDto.longitude,
            item.serviceProviderDto.providerPositionDto.latitude,
          ]);
          item_list.push({
            userDto: item.serviceProviderDto.userDto,
            appraise: item.appraise,
            distance: item.distance,
            fileUrl: item.serviceProviderDto.userDto.fileDtoList[0].fileUrl,
            time: item.time,
            longitude_latitude: list,
            receiveNick:item.serviceProviderDto.receiveNick
          });
        });
        // this.pagingServiceList = item_list;
        this.pagingServiceList = [...this.pagingServiceList,...item_list]
        console.log("item_list", this.pagingServiceList);
      }
    },
    acceptOrderData(data) {
      console.log("工单信息----------", data);
      if(data.platformStatisticDto){
        let praise  = (data.platformStatisticDto.goodNum/(data.platformStatisticDto.badNum + data.platformStatisticDto.goodNum))*100
        this.platformStatistic.earningsTotal = data.platformStatisticDto.earningsTotal
        this.platformStatistic.praise =  praise.toFixed(2)
        this.platformStatistic.orderTotal = data.platformStatisticDto.orderTotal
      }
       
    },
    acceptWeatherData(data) {
      console.log("天气信息----------", data);
      if (data && data.weatherDto) {
        this.weatherDto = data.weatherDto;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
#dd-left {
  width: 1920px;
  height: 1080px;
  position: relative;
  /* background-color: #000; */
}
.top-content {
  position: fixed;
  left: 0;
  top: 0;
}
.top-bg-img {
  width: 1919px;
  height: 80px;
  background-image: url("../assets/dd/dd-top-ico.png");
  background-repeat: no-repeat;
  /* background-size: 1919px 80px; */
  display: flex;
  justify-content: space-between;
}
.dd-type-name {
  width: 570px;
  height: 80px;
  /* text-align: center; */
  font-size: 44px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 6px;
  margin-left: 43px;
  line-height: 70px;
}
.dd-top-right {
  display: flex;
}
.dd-top-weather {
}
.dd-top-tiem {
  font-size: 38px;
  color: #a2c6f9;
  height: 80px;
  width: 200px;
  letter-spacing: 5px;
  line-height: 80px;
  margin-right: 60px;
}
/* 服务商列表 */
.dd-service-list {
  position: fixed;
  top: 125px;
  left: 30px;
  background-image: url("../assets/dd/dd-bg48.png");
  background-repeat: no-repeat;
  width: 331px;
  height: 932px;
  padding-top: 33px;
}
.dd-service-text {
  width: 319px;
  height: 42px;
  background-image: url("../assets/dd/dd-icon07.png");
  background-repeat: no-repeat;
  margin-left: 4px;
  line-height: 42px;
}
.dd-service-text-name {
  margin-left: 18px;
  font-weight: bold;
  background: linear-gradient(#77cdff, #0f42d3);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.dd-service-input {
  width: 331px;
  display: flex;
  justify-content: center;
  margin: 23px 0;
}
.dd-service-input /deep/.el-input .el-input__inner {
  height: 34px;
  width: 286px;
  border-radius: 20px;
  border: 1px solid #0275c8;
  background: #0c1b32;

  background: linear-gradient(#77cdff, #0f42d3);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
/* 人数 */
.dd-number-people {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.number-people {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.line {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 26px;
}
.on-line {
  background-image: url("../assets/dd/dd-scanning4.png");
  background-repeat: no-repeat;
  color: #00dfff;
}
.on-line-text {
  font-size: 14px;
  color: #00dfff;
  margin-top: 8px;
}
.dd-on-scanning2 {
  width: 71px;
  height: 70px;
  background-image: url("../assets/dd/dd-scanning2.png");
  background-repeat: no-repeat;
  background-position: center;
  animation: scanning 5s infinite linear;
  z-index: 9;
  position: absolute;
}
.off-line {
  background-image: url("../assets/dd/dd-scanning3.png");
  background-repeat: no-repeat;
  color: #f83b44;
}
.off-line-text {
  font-size: 14px;
  color: #f83b44;
  margin: 8px;
}
.dd-off-scanning {
  width: 71px;
  height: 70px;
  background-image: url("../assets/dd/dd-scanning.png");
  background-repeat: no-repeat;
  background-position: center;
  animation: scanning 4.8s infinite linear;
  z-index: 9;
  position: absolute;
}
.dd-number-people-list {
  margin-top: 10px;
  margin-right: 8px;
}
.number-people-list {
  width: 100%;
  height: 600px;
  overflow: hidden;
  overflow-y: scroll;
}
.number-people-list::-webkit-scrollbar {
  width: 4px;
  height: 2px;
  padding-right: 2px;
}
.number-people-list::-webkit-scrollbar-thumb {
  background: #0096ff;
  border-radius: 2px;
}
.list-item {
  height: 68px;
  padding: 0px 24px 0 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-people {
  display: flex;
  color: #fff;
  font-size: 14px;
}
.item-img {
  width: 40px;
  height: 40px;
  background-color: #77cdff;
  border-radius: 50%;
}
.people-distance {
  margin-left: 15px;
}
.least-text {
  font-size: 12px;
  color: #265f94;
  margin-top: 5px;
}
.dd-icon03 {
  width: 11px;
  height: 14px;
  background-image: url("../assets/dd/dd-icon03.png");
  background-repeat: no-repeat;
  display: inline-block;
}
.item-state {
  display: flex;
  align-items: center;
}
.dd-on-butt {
  width: 54px;
  height: 20px;
  border: 2px solid #00ffff;
  border-radius: 6px;
  color: #00ffff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.on-spot {
  width: 1px;
  height: 1px;
  border: 2px solid #00ffff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.dd-off-butt {
  width: 54px;
  height: 20px;
  border: 2px solid #f83b44;
  border-radius: 6px;
  color: #f83b44;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.off-spot {
  width: 1px;
  height: 1px;
  border: 2px solid #f83b44;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.dd-icon06 {
  width: 4px;
  height: 9px;
  margin-left: 15px;
}
/* 数据总览 */
.dd-overview {
  position: fixed;
  left: 450px;
  bottom: 25px;
}
/*  */
.dd-overview-top{
  position: absolute;
  left: 100px;
  top: -48px;
}
.bott-butt {
  width: 100px;
  height: 40px;
  font-size: 18px;
  font-weight: bold;
  background: linear-gradient(#e2ebff, #80e5f6);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  border-radius: 8px;
  border: 2px solid #149eff;
}
/*  */
.overview {
  width: 1372px;
  height: 203px;
  background-image: url("../assets/dd/dd-bg1.png");
  background-repeat: no-repeat;
  padding-top: 30px;
  position: relative;
}
.dd-overview-text {
  width: 319px;
  height: 42px;
  background-image: url("../assets/dd/dd-icon07.png");
  background-repeat: no-repeat;
  margin-left: 4px;
  line-height: 42px;
  position: absolute;
  top: 15px;
  left: 0px;
}
.dd-overview-text-name {
  margin-left: 18px;
  font-weight: bold;
  background: linear-gradient(#77cdff, #0f42d3);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.overview-bott {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.overview-item {
  display: flex;
  align-items: center;
}
.overview-bg {
  width: 146px;
  height: 102px;
  background-image: url("../assets/dd/dd-bg51.png");
  background-repeat: no-repeat;
  padding: 20px;
  box-sizing: border-box;
  margin-left: 10px;
}
.people {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}
.peopleW {
  display: inline-block;
  width: 52px;
}
.people-color {
  color: #ff952a;
  font-size: 20px;
}
.people-color2 {
  color: #00e9ff;
  font-size: 20px;
}
.dd-icon {
  width: 174px;
  height: 198px;
}
.overview-text {
  font-size: 36px;
  margin-bottom: 20px;
  background: linear-gradient(#e2ebff, #80e5f6);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.overview-least-text {
  font-size: 14px;
  color: #fff;
}
/* 天气 */
.right-weather {
  width: 482px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  position: relative;
}
.weather--menu-icon {
  margin-left: 10px;
  display: inline-block;
  width: 32px;
  height: 32px;
  /* position: absolute;
    left: 55px;
    top: 53px; */
}
.weather-icon {
  position: absolute;
  top: 8px;
  left: 30px;
}
.sun {
  background: url(../assets/sun.png) center no-repeat;
  background-size: cover;
}

.cloudy {
  background: url(../assets/cloudy.png) center no-repeat;
  background-size: cover;
}

.overcast {
  background: url(../assets/overcast.png) center no-repeat;
  background-size: cover;
}

.rain {
  background: url(../assets/rain.png) center no-repeat;
  background-size: cover;
}

.snow {
  background: url(../assets/snow.png) center no-repeat;
  background-size: cover;
}
.right-weather > div {
  font-size: 20px;
  color: #a2c6f9;
  margin-left: 15px;
  height: 50px;
  display: inline-block;
}
.right-weather  span{
    font-size: 20px;
}
/* 伪类 */
.item-icon {
  background-image: url("../assets/dd/dd-icon08.png");
  background-repeat: no-repeat;
  background-size: 100% 68px;
}
/* 动画 */
@keyframes scanning {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/dd_left.vue